import React, { useEffect } from "react";
import { connect } from "react-redux";
import "../../../Dashboard/dashboard.css";
import {
  generateForecastedGWC,
  updateForecastedGWC
} from "../../../../store/modules/forecastGWC/actions";
import InputLabel from "@mui/material/InputLabel";
import { rowStyle } from "../../../Dashboard/customStyles";
import BVAInput from "../../../../components/BVAInput/BVAInput";
import CurrencyFormatter from "currency-formatter";
import FinancialHandler from "../../../../handlers/FinancialHandler";

const ForecastGWC = ({
  appState,
  currentForecastGWC,
  dispatchUpdateForecastedGWC,
  dispatchGenerateForecastedGWC
}) => {
  useEffect(() => {
    dispatchGenerateForecastedGWC()
  }, [])

  const handleOnChange = (key, value) => {
    dispatchUpdateForecastedGWC({
      [key]: key === "analystNote" ? value : CurrencyFormatter.unformat(value, { code: "USD" })
    })
  }

  const handleOnClickGPT = async () => {
    handleOnChange("analystNote", "Generating...");
    const payload =
      "Based on our forecasted revenue, we input the percentage of non-cash working capital required to fund our working capital growth in revenue. This gives us our required annual investment for the next year.\nHere are the company's working capital forecast data." +
      "\nRevenue Estimate: " + Number(currentForecastGWC?.forecastRevenue).toFixed(2) + "$" +
      "\nNon-Cash Working Capital Percentage of Revenue: " + Number(currentForecastGWC?.nonCashWorkingCapitalPercentageRevenue).toFixed(2) + "%" +
      "\nNon-Cash Working Capital Amount: " + Number(currentForecastGWC?.nonCashWorkingCapitalAmount).toFixed(2) + "$" +
      "\nGrowth Rate: " + Number(currentForecastGWC?.growthRate * 100 - 100).toFixed(2) + "%" +
      "\nForecasted Non-Cash Working Capital Amount: " + Number(currentForecastGWC?.futureNonCashWorkingCapitalAmount).toFixed(2) + "$" +
      "\nRequired Investment: " + Number(currentForecastGWC?.requiredAnnualInvestment).toFixed(2) + "$" +
      "\nPlease analyze this company's forecasted working capital situation."
    const note = await FinancialHandler.fetchGPTSimpleNoteGeneration(payload);
    handleOnChange("analystNote", note);
  }

  return (
    <>
      <h2 className="sectionHead">Forecasted Growth in Working Capital</h2>
      <div className="dashboard-content">
        <div className="data-title-container">
          <div></div>

          <div className="data-title">
            <h6>{appState.companyData.name}</h6>
            <p>Growth in Working Capital Long-Term Forecast</p>
          </div>
        </div>

        <div style={rowStyle.baseRow}>
          <div style={rowStyle.labelRow}>
            <InputLabel>Revenue Estimate</InputLabel>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              width: "50%",
            }}
          >

            <BVAInput
              disabled
              size="small"
              id="gwc-forecastedRevenue"
              startAdornment
              startAdornmentLabel="$"
              value={currentForecastGWC?.forecastedRevenueFormatted}
            />
          </div>
        </div>

        <div style={rowStyle.baseRow}>
          <div style={rowStyle.labelRow}>
            <InputLabel>Non-Cash Working Capital % of Revenue</InputLabel>
          </div>
          <div style={rowStyle.fieldRow}>
            <BVAInput
              size="small"
              id="gwc-nonCashWorkingCapitalRevenue"
              endAdornment
              textAlign="end"
              endAdornmentLabel="%"
              startAdornment
              startAdornmentLabel="x"
              value={currentForecastGWC?.nonCashWorkingCapitalPercentageRevenue}
              onChange={(value) => handleOnChange("nonCashWorkingCapitalPercentageRevenue", value)}
            />
          </div>
        </div>

        <div style={rowStyle.baseRow}>
          <div style={rowStyle.labelRow}>
            <InputLabel>Non-Cash Working Capital Amount</InputLabel>
          </div>
          <div style={rowStyle.fieldRow}>
            <BVAInput
              disabled
              size="small"
              id="gwc-nonCashWorkingCapitalAmount"
              startAdornment
              startAdornmentLabel="$"
              value={currentForecastGWC?.nonCashWorkingCapitalAmountFormatted}
            />
          </div>
        </div>

        <div style={rowStyle.baseRow}>
          <div style={rowStyle.labelRow}>
            <InputLabel>1 + Growth Rate</InputLabel>
          </div>
          <div style={rowStyle.fieldRow}>
            <BVAInput
              disabled
              size="small"
              id="gwc-growthRate"
              startAdornment
              startAdornmentLabel="x"
              value={currentForecastGWC?.growthRate}
            />
          </div>
        </div>

        <div style={rowStyle.baseRow}>
          <div style={rowStyle.labelRow}>
            <InputLabel>Future Non-Cash Working Capital Amount</InputLabel>
          </div>
          <div style={rowStyle.fieldRow}>
            <BVAInput
              disabled
              size="small"
              id="gwc-forecastedValue"
              startAdornment
              startAdornmentLabel="$"
              value={currentForecastGWC?.futureNonCashWorkingCapitalAmountFormatted}
            />
          </div>
        </div>

        <div style={rowStyle.baseRow}>
          <div style={rowStyle.labelRow}>
            <InputLabel style={{ fontWeight: "bold" }}>
              Required Annual Investment
            </InputLabel>
          </div>
          <div style={rowStyle.fieldRow}>
            <BVAInput
              disabled
              size="small"
              id="gwc-forecastedValue"
              startAdornment
              startAdornmentLabel="$"
              value={currentForecastGWC?.requiredAnnualInvestmentFormatted}
            />
          </div>
        </div>

        <div className="data-bottom mt-10 mr-20 pr-20" style={{ width: "45em" }}>
          <h5 className="noteHead">Analyst Note&nbsp;&nbsp;&nbsp;<button onClick={() => handleOnClickGPT()}>🤖</button></h5>
          <textarea
            className="analystNote"
            rows={3}
            value={currentForecastGWC?.analystNote}
            onChange={(e) => handleOnChange("analystNote", e.target.value)}
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  forecastRev: state.forecastRev,
  currentForecastGWC: state.forecastGWC.currentForecastGWC,
  taxes: state.taxes,
  appState: state.appState,
})

const mapDispatchToProps = (dispatch) => ({
  dispatchGenerateForecastedGWC() {
    dispatch(generateForecastedGWC())
  },
  dispatchUpdateForecastedGWC({ nonCashWorkingCapitalPercentageRevenue, analystNote }) {
    dispatch(updateForecastedGWC({ nonCashWorkingCapitalPercentageRevenue, analystNote }))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(ForecastGWC);
